import React from 'react'
import { Modal, ModalHeader, ModalBody, ModalFooter, Row, Col } from 'reactstrap';
import ButtonModal from './ButtonModal';

function ConfirmationModal({
    show,
    toggle,
    title,
    message,
    isDelete,
    children,
    icon,
    close,
    variantIcon,
    isCancel,
    isConfirm,
    confirm,
    isLoading = false
}) {

    return (
        <>
            <Modal isOpen={show} modalTransition={{ timeout: 700 }} backdropTransition={{ timeout: 1300 }}
                toggle={isLoading ? undefined : toggle} backdrop={isLoading ? "static" : true} keyboard={!isLoading}>
                <ModalHeader className="text-extra-bold pt-5"> {title ?? "Konfirmasi"} {!isLoading && <span className="close clickable click-in-right" onClick={toggle}>&times;</span>}</ModalHeader>
                <ModalBody>
                    <div style={{ marginLeft: 20, display: 'flex', lineHeight: '2rem' }}>
                        {icon && <i className={`material-icons-outlined icon-modal ${variantIcon}`} style={{}}>{icon}</i>}
                        {message && <p style={{ fontSize: '16px' }}>{message}</p>}
                        {children}
                    </div>
                </ModalBody>
                <ModalFooter>
                    <ButtonModal
                        toggle={isLoading ? undefined : toggle}
                        deleted={isDelete}
                        confirm={confirm}
                        cancelTitle={isCancel ?? 'Batal'}
                        confirmTitle={isLoading ? 'Sedang memproses...' : (isConfirm ?? 'Simpan')}
                        disabled={isLoading}
                    />
                </ModalFooter>
            </Modal>
        </>
    )
}

export default ConfirmationModal
